export interface HandleRefSplitProps<T> {
    ownRef?: React.Ref<T>;
    forwardedRef?: React.Ref<T>;
}

const applyToRef =
    <T>(instance: T) =>
    (ref?: React.Ref<T>) => {
        if (ref) {
            if (typeof ref === 'function') {
                ref(instance);
            } else {
                // React refs are currently read-only. Potentially fixed by new react types or using hooks.
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (ref as any).current = instance;
            }
        }
    };

export const handleRefSplit =
    <T>({ ownRef, forwardedRef }: HandleRefSplitProps<T>) =>
    (instance: T) => {
        const applyInstanceToRef = applyToRef(instance);
        applyInstanceToRef(ownRef);
        applyInstanceToRef(forwardedRef);
    };
